// import { getLangPath } from '@translations/AppLanguage';
import { Routes } from "@navigator/Routes";
import { updateTenant } from "@utils/UpdateTenant";
export enum URLs {
  // Default
  default = "default",

  // Auth
  home = "home",
  login = "login",
  forgotPassword = "forgotPassword",
  forgotPasswordVerifyOtpScreen = "forgotPasswordVerifyOtpScreen",
  resetPassword = "resetPassword",
  createProfile = "createProfile",
  register = "register",
  organization = "organization",
  changePassword = "changePassword",
  forms = "forms",
  folder = "folder",
  respondedForms = "respond-forms",
  templates = "templates",
  pricing = "subscription",
  formSubmission = "form-submission",
  formLinkSubmission = "formlink-submission",
  formBuilder = "form-builder",
  sagaPoc = "saga-poc",
  getstarted = "getstarted",
  profile = "profile",
  dashboard = "dashboard",
  public_layout = "public_layout",
  profiledetail = "profiledetail",
  submissions = "submissions",
  response = "response",
  formLinkResponse = "form-formlink-response",
  verifyRegistrationOtp = "verifyRegistrationOtp",
  verifyGoogleRegistrationOtp = "verifyGoogleRegistrationOtp",
  googleRegistration = "googleRegistration",
  statistics = "statistics",
  paymentSuccessFul = "paymentSuccessFul",
  paymentFailure = "paymentFailure",
  editResponse = "editResponse",
}

export interface IRouteParams {
  profileId?: string;
  type?: string;
  eventId?: string;
  formId?: string;
  submissionId?: string;
  folderPath?: string;
  templateId?:string;
   roleName?:string
}

const generate = (url: URLs, params?: IRouteParams) => {
  switch (url) {
    case URLs.default:
      return updateTenant(Routes.Home.default);
    /**
     *  Auth URLs
     */
    case URLs.home:
      return updateTenant(Routes.Home.home);

    case URLs.login:
      return updateTenant(Routes.Auth.login);

    case URLs.forgotPassword:
      return updateTenant(Routes.Auth.forgotPassword);

    case URLs.register:
      return updateTenant(Routes.Auth.register);

    case URLs.changePassword:
      return updateTenant(Routes.Auth.changePassword);

    case URLs.submissions:
      return updateTenant(
        Routes.Forms.default + "/" + params.formId + Routes.Submissions.default
      );

    case URLs.forms:
      return updateTenant(Routes.Forms.default);

    case URLs.folder:
      return updateTenant(
        `${Routes.FormsFolder.default}${
          params?.folderPath ? "/" + params?.folderPath : ""
        }`
      );

    case URLs.respondedForms:
      return updateTenant(Routes.RespondedForms.default);
 
    case URLs.templates:
      return updateTenant(Routes.Templates.default);

    case URLs.pricing:
      return updateTenant(Routes.Pricing.default);

    case URLs.formBuilder:
      return updateTenant(Routes.FormBuilder.default + "/" + params.formId);

    case URLs.formSubmission:
      return updateTenant(Routes.FormSubmission.default + "/" + params.formId);

    case URLs.formLinkSubmission:
      return updateTenant(
        Routes.FormLinkSubmission.default + "/" + params.formId
      );

    case URLs.response:
      return updateTenant(Routes.Response.default + "/" + params.submissionId);

    case URLs.formLinkResponse:
      return updateTenant(Routes.formLinkResponse.default + "/" + params.submissionId);

    case URLs.editResponse:
      return updateTenant(
        Routes.EditResponse.default + "/" + params.submissionId
      );

    case URLs.getstarted:
      return updateTenant(Routes.Auth.default);

    case URLs.profile:
      return updateTenant(Routes.Profile.default + "/" + params.profileId);

    case URLs.profiledetail:
      return updateTenant(
        Routes.profileDetail.default + "/" + params.profileId
      );
    // return Routes.profileDetail.default;

    case URLs.organization:
      return updateTenant(Routes.Profile.organization);

    case URLs.dashboard:
      return updateTenant(Routes.Dashboard.default);

    case URLs.verifyRegistrationOtp:
      return updateTenant(Routes.Auth.verifyRegistrationOtp);

    case URLs.verifyGoogleRegistrationOtp:
      return updateTenant(Routes.Auth.verifyGoogleRegistrationOtp);

    case URLs.googleRegistration:
      return updateTenant(Routes.Auth.googleRegistration);

    case URLs.forgotPasswordVerifyOtpScreen:
      return updateTenant(Routes.Auth.forgotPasswordVerifyOtpScreen);

    case URLs.paymentSuccessFul:
      return updateTenant(Routes.payment.success);

    case URLs.paymentFailure:
      return updateTenant(Routes.payment.failure);

    case URLs.resetPassword:
      return updateTenant(Routes.Auth.resetPassword);

    case URLs.statistics:
      return updateTenant(
        Routes.Forms.default + Routes.Statistics.stats + "/" + params.formId
      );

    default:
      return updateTenant(Routes.Home.default);
  }
};

export const NavigationUrl = {
  generate,
};
